import React, {useEffect, useMemo, useRef, useState } from "react";
import moment from "moment";
import { Tabs, Tooltip } from "antd";
import { Spin, Modal, message,Badge } from "antd";
import {
  getFirstDateOfWeek,
  getLastDateOfWeek,
  getMySqlDate,
} from "utils/Date";
import LeaveForm from "organisms/LeaveForm";
import { CALL_API } from "common/API";
import { connect } from "react-redux";
import {
  getAllDepartmentList,
  getUserRoleId,
  getSelectedDepartmentId,
  getUserInfo,
  getClientid,
  getMenuList,
  getLeaveCategoryList,
  getUserList,
  getRoleList,
} from "redux/selectors";
import {
  get,
  includes,
  isEmpty,
  orderBy,
  some,
} from "lodash";
import { getAllSubordinates, STATUS_CODE } from "common/Constants";
// import { CalendarContext } from ".";
import queryKeys from "common/queryKey";
import { useFetch } from "hooks/useFetch";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import StaffLeaveIndicatorInCalendar from "pages/Calendar/StaffLeaveIndicatorInCalendar";
import {StyledHolidayBadge} from "../Calendar/StyledComponents";
import { useSelector } from "react-redux";
import styled from "styled-components";
const Stylediv=styled.div`
.fc .fc-holiday-week {
  background-color: rgba(255, 0, 0, 0.2) !important;
}
`;
function LeaveWeekCalendar({
  userRoleId,
  userInfo,
  ClientId,
  menuList,
  userList,
  setTabId,
  tabId,
  clientId
}) {

  const [holidayList, setHolidayList] = useState([]);
  const getHolidayList = async ( startdate, enddate) => {
    try {
      const response = await CALL_API(`holiday-list/${ClientId}`, "post", {
        start_date: moment(startdate).format("yyyy-MM-DD"),
        end_date: moment(enddate).format("yyyy-MM-DD"),
      });
      if(!isEmpty(response)){
        setHolidayList(orderBy(response, ["start_date"], ["asc"]))
      }else{
        setHolidayList([])
      }
    } catch (error) {
      console.log("[getHolidayList], Error-->", error);
    }
  };

  const { TabPane } = Tabs;
  const Menulist = menuList[userRoleId] || Object.values(menuList)[0];
  
  let tabMenus = Menulist.filter(
    (item) =>
      item.key === "mycalendar" ||
      item.key === "teamcalendar" ||
      item.key === "allcalendar"
  );

  let newArray = [];
  newArray.push(...tabMenus);

  const items =
    newArray &&
    newArray
      ?.filter((data) => data.access === true)
      .map((data, index) => ({
        id: data.subtitle,
        label: data.subtitle,
        component: <></>,
      }));

  const [activeTab, setActiveTab] = useState("Mine");

  const [displayLeaveModal, toggleLeaveModal] = useState(false);

  const [leaveDetails, setLeaveDetails] = useState({});
  const [showMyTeamLeaves, toggleMyTeamLeave] = useState(false);

  const filteruser = userList?.filter(
    (item) => item?.userid === userInfo.userid
  );

  const isSuperAdmin = userInfo?.roleId === "2";
  const isCountryAdmin = userInfo?.roleId === "3";

  const [payload, setPayload] = useState({
    status_id: "4,5",
    officesupervisorid: [""],
    selected_role_id: "0",
    start_date: getFirstDateOfWeek(moment()),
    end_date: getLastDateOfWeek(moment()),
    show_my_team_leave: tabId === "My Team" ? true : false,
    ...(isSuperAdmin && { supeAdmin: true }),
    ...(isCountryAdmin && { countryAdmin: true }),
    ...(isCountryAdmin && { country: filteruser[0]?.managingoffice[0] }),
  });
  const [endDate, setEndDate] = useState("");

  moment.updateLocale("en", {
    weekdaysMin: ["S", "M", "T", "W", "T", "F", "S"],
  });

  const subordinates = getAllSubordinates(userList, filteruser[0]?.employeeid);

  const handleTabSelect = (key) => {
    const activeTab = items.find((item) => item.id === key);
    if (activeTab) {
      setTabId(activeTab.label);
    }

    if (key === 0) {
      toggleMyTeamLeave(!showMyTeamLeaves);
    }
  };

  const calendarRef = useRef(null);

  const queryString = new URLSearchParams(payload).toString();

  const { key, url } = queryKeys.getLeaveList(ClientId, queryString);

  const {
    data: leaveDataRes,
    isLoading: displayLoader,
    refetch: getLeaveList,
  } = useFetch(
    key,
    url,
    {
      enabled: !!ClientId,
    },
    payload
  );

  const MyleaveList = leaveDataRes?.response?.leaves?.filter(
    (val) => val?.userid === get(userInfo, "userid", "")
  );

  const myTeamLeaveList = leaveDataRes?.response?.teamLeaves?.filter((val) => {
    return subordinates.includes(val?.officesupervisorid);
  });

  const allLeaveList = leaveDataRes?.response?.leaves?.filter((val) => {
    return val;
    // if (filteruser[0].OfficeSupervisorId === "none") {
    //   return val;
    // } else {
    //   const findUser = userList?.filter(
    //     (item) => item?.employeeid === val.employeeid
    //   );
    //   const isSameCountry = some(findUser[0]?.managingoffice, (value) =>
    //     includes(filteruser[0]?.managingoffice, value)
    //   );
    //   return isSameCountry;
    // }
  });

  const addLeave = (event, cellDate) => {
    if (userRoleId != 1) {
      const isPastDate =
        moment(getMySqlDate(cellDate)) < moment(getMySqlDate("2022-08-01"));
      if (!isPastDate) {
        toggleLeaveModal(true);
        setLeaveDetails({
          start_date: cellDate,
          end_date: cellDate,
        });
      }
    }
  };

  const cancelLeaveRequest = (details) => {
    const {
      user_leave_id,
      start_date: leave_start_date,
      end_date: leave_end_date,
      status_id,
      userid
    } = details;
    if (userRoleId !== 1 && status_id !== "4") {
      Modal.confirm({
        icon: "",
        content: "Are you sure you want to cancel your leave application?",
        okText: "Yes",
        cancelText: "No",
        onOk: () => {
          return new Promise(async (resolve) => {
            const { code } = await CALL_API(
              `approve-reject-cancel-leave/${ClientId}`,
              "post",
              {
                user_leave_id,
                status_id: "9",
                is_cancel_request: false,
                start_date: getMySqlDate(leave_start_date),
                end_date: getMySqlDate(leave_end_date),
                leave_applied_userid: userid
              }
            );
            if (code === STATUS_CODE.SOMETHING_WENT_WRONG) {
              message.error(`Oops!! something went wrong.`);
            } else if (code === STATUS_CODE.INVALID_PAYLOAD) {
              message.error(`Invalid payload. Please enter correct data.`);
            } else if (code === STATUS_CODE.RECORD_EXIST) {
              message.error(`Leave aleady exist.`);
            } else if (code === STATUS_CODE.SUCCESS) {
              message.success(`Your leave application has been cancelled.`);
              getLeaveList();
            }
            resolve();
          }).catch((err) => console.log("[cancelLeaveRequest] Error -->", err));
        },
      });
    } else {
      setLeaveDetails(details);
      toggleLeaveModal(true);
    }
  };

  const cancelLeave = (details) => {
    const {
      user_leave_id,
      start_date: leave_start_date,
      end_date: leave_end_date,
      status_id,
      userid
    } = details;
    if (userRoleId !== 1 && status_id === "4") {
      Modal.confirm({
        icon: "",
        content: "Are you sure you want to cancel your leave application?",
        okText: "Yes",
        cancelText: "No",
        onOk: () => {
          return new Promise(async (resolve) => {
            const { code } = await CALL_API(
              `approve-reject-cancel-leave/${ClientId}`,
              "post",
              {
                user_leave_id,
                status_id: "9",
                is_cancel_request: false,
                start_date: getMySqlDate(leave_start_date),
                end_date: getMySqlDate(leave_end_date),
                leave_applied_userid: userid
              }
            );
            if (code === STATUS_CODE.SOMETHING_WENT_WRONG) {
              message.error(`Oops!! something went wrong.`);
            } else if (code === STATUS_CODE.INVALID_PAYLOAD) {
              message.error(`Invalid payload. Please enter correct data.`);
            } else if (code === STATUS_CODE.RECORD_EXIST) {
              message.error(`Leave aleady exist.`);
            } else if (code === STATUS_CODE.SUCCESS) {
              message.success(`Your leave application has been cancelled.`);
              getLeaveList();
            }
            resolve();
          }).catch((err) => console.log("[cancelLeave] Error-->", err));
        },
      });
    } else {
      setLeaveDetails(details);
      toggleLeaveModal(true);
    }
  };

const memoizedMyLeaveList = useMemo(() => MyleaveList, [MyleaveList]);
  const memoizedMyTeamLeaveList = useMemo(
    () => myTeamLeaveList,
    [myTeamLeaveList]
  );
  const memoizedAllLeaveList = useMemo(() => allLeaveList, [allLeaveList]);
  const events = useMemo(() => {
    let leaveList = [];
    switch (activeTab) {
      case "Mine":
        leaveList = memoizedMyLeaveList;
        break;
      case "My Team":
        leaveList = memoizedMyTeamLeaveList;
        break;
      case "All":
        leaveList = memoizedAllLeaveList;
        break;
      default:
        leaveList = memoizedMyLeaveList;
    }
    return leaveList?.map((event) => {
      const isCancelRequested =
        event.status_id === "5" && event.having_cancel_request === "1";
      const rawStartDate = isCancelRequested
        ? event.new_start_date
        : event.start_date;
      const rawEndDate = isCancelRequested
        ? event.new_end_date
        : event.end_date;
      const startDateTime = moment(rawStartDate)
        .set({ hour: 8, minute: 0 })
        .toISOString();
      const endDateTime = moment(rawEndDate)
        .set({
          hour: Number(event.number_of_days) === 0.5 ? 12 : 17,
          minute: 0,
        })
        .toISOString();
      return {
        id: event.id || `${event.fullname}-${rawStartDate}`, // Add unique id
        title: `${event.fullname} | ${event.leave_category_name}`,
        start: startDateTime,
        end: endDateTime,
        status: event.status_id,
        having_cancel_request: event.having_cancel_request,
        ...event,
      };
    });
  }, [
    activeTab,
    memoizedMyLeaveList,
    memoizedMyTeamLeaveList,
    memoizedAllLeaveList,
  ]);

  const getEventColor = (statusId, havingCancelRequest) => {
      if (statusId === "5" && havingCancelRequest === "1") {
    return "#FBE2CD"; // same as status 4’s orange
  }
    switch (parseInt(statusId, 10)) {
      case 4:
        return "#FBE2CD"; // Orange
      case 5:
        return "#E2FBCD"; // Light Blue
      case 6:
        return "#FFCCCB"; // Light Red
      default:
        return "#ADD8E6"; // Default to white
    }
  };

  const getEventBorderColor = (statusId, havingCancelRequest) => {
    if (statusId === "5" && havingCancelRequest === "1") {
      return "#F18D38"; // same as status 4’s border
    }
    switch (parseInt(statusId, 10)) {
      case 4:
        return "#F18D38";
      case 6:
        return "#38CDF1";
      case 5:
        return "#78F138";
      default:
        return "#F18D38";
    }
  };

  const textStyle = {
    whiteSpace: "nowrap", // Prevent wrapping
    overflow: "hidden", // Hide overflow
    textOverflow: "ellipsis", // Show ellipsis for overflow
  };

  const handleDatesSet = (arg) => {
    const startOfWeek = arg.start; // Start of the week (Date object)
    const endOfWeek = arg.end; // End of the week (Date object)
    const viewType = arg.view.type

    // You can format these dates as needed
    const formattedStart = startOfWeek.toISOString().split("T")[0];
    const formattedEnd = endOfWeek.toISOString().split("T")[0];

    setPayload({
      status_id: "4,5",
      officesupervisorid: [""],
      selected_role_id: "0",
      start_date: moment(formattedStart).format("YYYY-MM-DD"),
      end_date: moment(formattedEnd).format("YYYY-MM-DD"),
      show_my_team_leave: tabId === "My Team" ? true : false,
      ...(isSuperAdmin && { supeAdmin: true }),
      ...(isCountryAdmin && { countryAdmin: true }),
      ...(isCountryAdmin && { country: filteruser[0]?.managingoffice[0] }),
    });

    getHolidayList(
      viewType === "dayGridMonth"
        ? moment(arg.view.getCurrentData().currentDate).startOf('month').format("YYYY-MM-DD")
        : moment(arg.start).format("YYYY-MM-DD"),
    
      viewType === "dayGridMonth"
        ? moment(arg.view.getCurrentData().currentDate).endOf('month').format("YYYY-MM-DD")
        : moment(arg.end).format("YYYY-MM-DD")
    );
  };

  const currentUser = userList?.find(
    (item) => item?.userid === userInfo.userid
  );
  const baselocationid = currentUser?.baselocationid;

  return (
    <>
    <Stylediv>
      <Spin spinning={displayLoader}>
        <FullCalendar
          ref={calendarRef}
          plugins={[timeGridPlugin, dayGridPlugin, interactionPlugin]}
          height="auto"
          dateClick={(info) => addLeave(info.event, info.date)}
          contentHeight="auto"
          initialView="timeGridWeek" // Set the initial view to week
          events={events} // Use your events array
          headerToolbar={{
            left: "prev,next", // Navigation buttons
            center: "title", // Title in the center
            right: "timeGridWeek,dayGridMonth", // Week and Month views on the right
          }}
          datesSet={handleDatesSet}
          editable={false}
          selectable={true}
          allDaySlot={false} // Disable the all-day slot
          eventOverlap={false} // Allow events to overlap
          slotEventOverlap={true} // Prevent events from stacking in the same slot
          eventLimit={3} // Limit the number of events shown in a slot
          slotMinTime="08:00:00" 
          slotMaxTime="18:00:00"
          eventLimitClick={"popover"}
          dayCellClassNames={(arg) => {
            if (arg.view.type !== "timeGridWeek") return [];
            const dateStr = moment(arg.date).format("YYYY-MM-DD");
            const isHoliday = holidayList.some(holiday =>
              moment(holiday.start_date).format("YYYY-MM-DD") <= dateStr &&
              moment(holiday.end_date).format("YYYY-MM-DD") >= dateStr &&
              holiday.location_id?.includes(baselocationid)
            );
            return isHoliday ? ["fc-holiday-week"] : [];
          }}
      dayCellContent={(arg) => {
        if (arg.view.type !== "dayGridMonth") {
      
        const dateStr = moment(arg.date).format("YYYY-MM-DD");
        const matchedHoliday = holidayList.find(holiday =>
            moment(holiday.start_date).format("YYYY-MM-DD") <= dateStr &&
            moment(holiday.end_date).format("YYYY-MM-DD") >= dateStr && holiday?.location_id?.includes(baselocationid)
        );
        return (
        <>
          <div>{arg.dayNumberText}</div>
          {matchedHoliday && (
            <div style={{ display: "flex", justifyContent: "center", fontSize: '14px', color: '#000', marginTop: "5px", fontWeight: "bold" }}>
              {matchedHoliday.holiday_name}
            </div>
          )}
        </>
        );
      } else {
        const dateStr = moment(arg.date).format("YYYY-MM-DD");
          const holiday = holidayList?.find(
            (holiday) =>
              moment(holiday.start_date).format("YYYY-MM-DD") <= dateStr &&
            moment(holiday.end_date).format("YYYY-MM-DD") >= dateStr && holiday?.location_id?.includes(baselocationid)
          );
          return (
            <>
            {holiday && (
              <Tooltip title={`${holiday.holiday_name}`}>
                <div
                  style={{
                    position: "absolute",
                    top: "22px",
                    left: "-10px",
                    zIndex: 8,
                  }}
                >
                  <StyledHolidayBadge>H</StyledHolidayBadge>
                </div>
              </Tooltip>
            )}
            <div>{arg.dayNumberText}</div>
          </>
          );
      }
    }}

          eventContent={(info) => {
            const {
              status_id,
              having_cancel_request: havingCancelRequest,
            } = info.event.extendedProps;

            const backgroundColor = getEventColor(status_id, havingCancelRequest);
            const borderColor = getEventBorderColor(status_id, havingCancelRequest);

            const startTime = info.event.start
              ? moment(info.event.start).format("hh:mm A")
              : "N/A";
            const endTime = info.event.end
              ? moment(info.event.end).format("hh:mm A")
              : "N/A";

            return (
              <StaffLeaveIndicatorInCalendar
                icon="team"
                leaveDetails={{ info, ...info.event.extendedProps }}
                isStaff={true}
                openEditLeaveModal={(details) => {
                  cancelLeaveRequest(details);
                }}
                EditLeaveModal={(details) => {
                  cancelLeave(details);
                }}
              >
                <div
                  style={{
                    padding: "5px",
                    background: backgroundColor,
                    border: "none",
                    outline: "none",
                    color: "#000",
                    border: `1px solid ${borderColor}`,
                    height: "110%",
                    minWidth: "auto",
                    width: "100%", // Full width
                    boxSizing: "border-box", // Ensure padding is included in width
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <>
                 <span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                   {info.event.title}
                 </span>
                 <p style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                   {moment(info.event.start).format("hh:mm A")} – {moment(info.event.end).format("hh:mm A")}
                 </p>
                  </>
                </div>
              </StaffLeaveIndicatorInCalendar>
            );
          }}
        />
      </Spin>
      </Stylediv>

      <LeaveForm
        isModalVisible={displayLeaveModal}
        closeModal={() => toggleLeaveModal(false)}
        leaveDetails={leaveDetails}
        getLeaveList={getLeaveList}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  userRoleId: getUserRoleId(state),
  allDepartmentList: getAllDepartmentList(state),
  selectedDepartmentId: getSelectedDepartmentId(state),
  userInfo: getUserInfo(state),
  ClientId: getClientid(state),
  menuList: getMenuList(state),
  leaveCategoryList: getLeaveCategoryList(state),
  userList: getUserList(state),
  roleList: getRoleList(state),
  clientId: getClientid(state),
});

export default connect(mapStateToProps, null)(LeaveWeekCalendar);
